module.exports = kolibriCoreAppGlobal.coreVue.mixins.commonCoreStrings;